// src/features/engine/components/TaskRenderer.jsx

import { useProgramEngine } from "../context/ProgramEngineContext";
import { useTaskRuntime } from "../context/TaskRuntimeContext";

import { resolveToolComponent } from "../toolRegistry";

export default function TaskRenderer({ step }) {

  const {
    currentStep
  } = useProgramEngine() || {};
  const { task, session } = useTaskRuntime();

  const effectiveStep = step || currentStep;

  if (!effectiveStep || !task || !session) {
    return <div>Loading...</div>;
  }

  const tool = task?.tool;

  if (!tool) {
    console.error("❌ No tool defined in task", { task });
    return <div>No tool defined</div>;
  }

  const ToolComponent = resolveToolComponent(tool);

  if (!ToolComponent) {
    console.error("❌ Unsupported tool:", tool);
    return <div>Unsupported tool: {tool}</div>;
  }

  return (
    <ToolComponent
      step={effectiveStep}
      task={task}
      session={session}
    />
  );
}
